import Vue from 'vue'
import Vuex from 'vuex'

import DateDefinedWarp from '@/api/DateDefinedWarp'
import store from "element-ui/packages/cascader-panel/src/store";

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
        iscur:null,//初始化设置为null，为了后面分享链接定位到那一页
        server: {
            
        },
        currentLanguage:'zh',
    },
    getters: {
        
    },
    mutations: {
       
    },
    modules: {
        // cart,
        // products
    },
    strict: false
    // plugins: debug ? [createLogger()] : []
})